/** Build-time wiring: which data the bundle uses and where its sibling surfaces live (see web/vite.shared.ts). */
import { parseConnection } from './domain/energy';
import { demoGateways } from './gateways/demo';
import { liveGateways } from './gateways/live';
import type { DataMode, Gateways } from './gateways/types';

declare const __P1PLUG_DATA__: DataMode | undefined;
declare const __P1PLUG_SURFACE_URLS__: Record<SurfaceName, string> | undefined;

export type SurfaceName = 'app' | 'backoffice' | 'portal' | 'developers' | 'factory' | 'fulfilment' | 'status';

const mode: DataMode = typeof __P1PLUG_DATA__ === 'undefined' ? 'demo' : __P1PLUG_DATA__;

export const SURFACE_URLS: Record<SurfaceName, string> =
  typeof __P1PLUG_SURFACE_URLS__ === 'undefined'
    ? { app: '#', backoffice: '#', portal: '#', developers: '#', factory: '#', fulfilment: '#', status: '#' }
    : __P1PLUG_SURFACE_URLS__;

/**
 * The gateways of this bundle. `connection` is the lab app's grid connection
 * ("1x25", "3x25" …): the platform does not store it yet, so it is configured.
 */
export function createGateways(options: { connection?: string } = {}): Gateways {
  if (mode === 'demo') return demoGateways();
  return liveGateways({ connection: parseConnection(options.connection, 'configured') });
}
